export const mapState = (state, fn) => {
    const mappedState = {};
    Object.keys(state).forEach((key) => {
        mappedState[key] = fn(state[key], key);
    });
    return mappedState;
};
